import { of, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PershingError, AdvisorContextValue } from '../models';
import { AdvisorListResponseObject } from '../models/advisor-response-object.model';
import { AdvisorListResponse } from '../models/advisor-response.model';
import { MOCK_ADVISORLIST_RESPONSE } from './org-context.response.mock';
import { IOrgContextService } from '../interfaces/org-context.abstract.service';

@Injectable()
export class OrgContextServiceMock implements IOrgContextService {
    advisorlistResponse$: Observable<AdvisorListResponse>;
    responseObject$: Observable<AdvisorListResponseObject>;
    error$: Observable<PershingError> = of(null);
    message: string[] = ['SYSTEM ERROR OCCURED'];
    id: string = '111111111';
    domain: string = 'advisor';
    advisorContextValue = new AdvisorContextValue(this.id);

    constructor() {
        this.advisorlistResponse$ = of(MOCK_ADVISORLIST_RESPONSE);
    }

    loadAdvisorList(): void {}
    setError(errorMessage: string, errorCode?: string): void {}
    clearError(): void {}
}
